<template>
  <el-card
    shadow="never"
    class="widget-panel"
  >
    <div
      slot="header"
      class="widget-panel__header"
    >
      <strong>{{ title }}</strong>
      <slot name="header-action">
        <el-button
          v-if="actionLabel"
          type="text"
          size="mini"
          @click="$emit('action')"
        >
          {{ actionLabel }}
        </el-button>
      </slot>
    </div>

    <div
      v-if="loading"
      v-loading="true"
      class="widget-panel__state"
    />
    <div
      v-else-if="empty"
      class="widget-panel__state text-muted font-italic"
    >
      {{ emptyText }}
    </div>
    <slot v-else>
      <p
        v-if="content"
        class="widget-panel__content"
      >
        {{ content }}
      </p>
    </slot>
  </el-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    actionLabel: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'No Data'
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-panel {
  height: 100%;
}

.widget-panel__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 20px;

  strong {
    color: #29313c;
    font-size: 13px;
  }
}

.widget-panel__state {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 140px;
}

.widget-panel__content {
  color: #59616d;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
}
</style>
